/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency';
import '../../../common/instrument';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "grantly": {
            "nested": {
              "api": {
                "nested": {
                  "InTransactionTopUpFlowEndResult": {
                    "fields": {
                      "inTransactionTopUpInfo": {
                        "type": "squareup.cash.grantly.api.InTransactionTopUpInfo",
                        "id": 1,
                        "rule": "optional"
                      },
                      "lastKnownStoredBalanceAmount": {
                        "type": "squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "resolution": {
                        "type": "squareup.cash.grantly.api.InTransactionTopUpFlowEndResult.InTransactionTopUpResolution",
                        "id": 3,
                        "rule": "optional"
                      },
                      "selectedTopUpAmount": {
                        "type": "squareup.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "preAuthTotalAmount": {
                        "type": "squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "InTransactionTopUpResolution": {
                        "values": {
                          "SKIPPED": 1,
                          "CONSUMER_INELIGIBLE": 2,
                          "CONSUMER_APPROVED": 3,
                          "CONSUMER_DECLINED": 4
                        }
                      }
                    }
                  },
                  "InTransactionTopUpInfo": {
                    "fields": {
                      "selectedInstrument": {
                        "type": "squareup.cash.grantly.api.Instrument",
                        "id": 1,
                        "rule": "optional"
                      },
                      "topUpAmount": {
                        "type": "squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "minimumRequiredTopUpAmount": {
                        "type": "squareup.common.Money",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "Instrument": {
                    "fields": {
                      "instrumentType": {
                        "type": "squareup.cash.grantly.api.Instrument.InstrumentType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "fideliusToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "instrumentToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "card": {
                        "type": "squareup.cash.grantly.api.Card",
                        "id": 4,
                        "rule": "optional"
                      },
                      "availableBalance": {
                        "type": "squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "InstrumentType": {
                        "values": {
                          "CREDIT_CARD": 1,
                          "DEBIT_CARD": 2,
                          "BANK_ACCOUNT": 3,
                          "STORED_VALUE": 4
                        }
                      }
                    }
                  },
                  "Card": {
                    "fields": {
                      "cardType": {
                        "type": "squareup.common.instrument.InstrumentType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cardPii": {
                        "type": "squareup.cash.grantly.api.Card.CardPii",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CardPii": {
                        "fields": {
                          "postalCode": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "expiration": {
                            "type": "squareup.cash.grantly.api.Expiration",
                            "id": 2,
                            "rule": "optional"
                          },
                          "lastFourDigits": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "ciphertext_": {
                            "type": "bytes",
                            "id": 3237,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "Expiration": {
                    "fields": {
                      "month": {
                        "type": "uint32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "year": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.InTransactionTopUpFlowEndResult && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.InTransactionTopUpFlowEndResult?.nested?.InTransactionTopUpResolution && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.InTransactionTopUpInfo && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Instrument && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Instrument?.nested?.InstrumentType && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Card && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Card?.nested?.CardPii && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Expiration) {
  $root.addJSON(jsonData);
}

/**
 * The following messages are copies of merbro-defined protos to resolve
 *   #cash-inc-5056_dependency-update-blocked-in-grantly
 * Copy of https://prototype.sqprod.co/#/docs/squareup.cash.merbro.plasma.InTransactionTopUpFlowEndResult
 *
 * SOURCE InTransactionTopUpFlowEndResult @ squareup/cash/grantly/api/in_transaction_top_up_flow_end_result.proto at 15:1
 */
export const InTransactionTopUpFlowEndResult = $root.lookupType('squareup.cash.grantly.api.InTransactionTopUpFlowEndResult');
fixType(InTransactionTopUpFlowEndResult);
Builder.createAndAttachToType(InTransactionTopUpFlowEndResult);
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.plasma.InTransactionTopUpFlowEndResult.InTransactionTopUpResolution
 *
 * SOURCE InTransactionTopUpResolution @ squareup/cash/grantly/api/in_transaction_top_up_flow_end_result.proto at 23:3
 */
InTransactionTopUpFlowEndResult.InTransactionTopUpResolution = $root.lookupEnum('squareup.cash.grantly.api.InTransactionTopUpFlowEndResult.InTransactionTopUpResolution').values;
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.plasma.InTransactionTopUpInfo
 *
 * SOURCE InTransactionTopUpInfo @ squareup/cash/grantly/api/in_transaction_top_up_flow_end_result.proto at 32:1
 */
export const InTransactionTopUpInfo = $root.lookupType('squareup.cash.grantly.api.InTransactionTopUpInfo');
fixType(InTransactionTopUpInfo);
Builder.createAndAttachToType(InTransactionTopUpInfo);
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.Instrument
 * Part of the InTransactionTopUpFlowEndResult definition;
 * DO NOT USE outside of that proto.
 *
 * SOURCE Instrument @ squareup/cash/grantly/api/in_transaction_top_up_flow_end_result.proto at 41:1
 */
export const Instrument = $root.lookupType('squareup.cash.grantly.api.Instrument');
fixType(Instrument);
Builder.createAndAttachToType(Instrument);
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.InstrumentType
 *
 * SOURCE InstrumentType @ squareup/cash/grantly/api/in_transaction_top_up_flow_end_result.proto at 49:3
 */
Instrument.InstrumentType = $root.lookupEnum('squareup.cash.grantly.api.Instrument.InstrumentType').values;
/**
 * SOURCE Card @ squareup/cash/grantly/api/in_transaction_top_up_flow_end_result.proto at 57:1
 */
export const Card = $root.lookupType('squareup.cash.grantly.api.Card');
fixType(Card);
Builder.createAndAttachToType(Card);
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.Card.CardPii
 * Part of InTransactionTopUpFlowEndResult;
 * DO NOT USE outside of that proto.
 *
 * SOURCE CardPii @ squareup/cash/grantly/api/in_transaction_top_up_flow_end_result.proto at 64:3
 */
Card.CardPii = $root.lookupType('squareup.cash.grantly.api.Card.CardPii');
fixType(Card.CardPii);
Builder.createAndAttachToType(Card.CardPii);
/**
 * https://prototype.sqprod.co/#/docs/squareup.cash.merbro.api.Expiration
 *
 * SOURCE Expiration @ squareup/cash/grantly/api/in_transaction_top_up_flow_end_result.proto at 74:1
 */
export const Expiration = $root.lookupType('squareup.cash.grantly.api.Expiration');
fixType(Expiration);
Builder.createAndAttachToType(Expiration);